/* 
COMPONENT CAN EDIT MOV, REMARKS AS OF 11.06.2018

*/
import React from 'react';
import { Button, Card, Col, Icon, Input, message, Row, Tooltip } from 'antd';

import { _postUpdatedSupplierDetails } from '../../../services';


class EditSupplierDetails extends React.Component {
    render() {
        const { editting, loading, movAmount, remarks } = this.state;


        if( !editting ) {
            return(
                <Row>
                    <Col span={8}>
                    </Col>

                    <Col span={16}>

                        <Row className="mov-component">
                            <Col span={20} >
                                <Row style={{paddingBottom: '8px'}}>
                                    <Col span={5} className="mov-header">
                                        MOV: 
                                    </Col>

                                    <Col span={4}>
                                        ${movAmount || 0}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span={8} className="mov-header">
                                        Remarks:
                                    </Col>

                                </Row>

                                <Row className="remarks-content">
                                    {remarks}
                                </Row>
                            </Col>
                            <Col span={4} >
                                <div
                                    // size="small"
                                    
                                    onClick={this.toggleEditMov}>
                                        <Icon className="mov-edit-icon" type="edit" /> 
                                </div>
                            </Col>

                        </Row>
                    </Col>
                </Row>
            )
        }

        return this.renderEditBox(movAmount, remarks, loading)
    }

    renderEditBox = (movAmount, remarks, loading) => {

        return (
            <Card
                className="mov-component mov-component-box"
                title="Edit"
                extra={
                    <Row type="flex" gutter={8}>
                        <Col span={12}>
                            <Button
                                onClick={this.handleSubmit}
                                loading={loading}
                                type="primary"
                                size="small"> 
                                Update
                            </Button>
                        </Col>

                        <Col span={12}>
                            <Button
                                onClick={this.handleCancel}
                                size="small"> 
                                Cancel
                            </Button>
                        </Col>
                        
                    </Row>
                }
                >
                <Row className="mov-input">
                    <Col span={6}>
                        MOV: 
                    </Col>  
                    
                    <Col span={18}>
                        <Tooltip
                            trigger={['focus']}
                            title="MOV >= $0"
                            placement="topLeft"
                            // overlayClassName="numeric-input"
                        >
                            <Input 
                            defaultValue={movAmount || 0}
                            placeholder="Enter MOV" 
                            name="movAmount"
                            prefix="$"
                            onChange={(e) => this.onInputChange(e)}
                            size="small" />
                        </Tooltip>
                    </Col>
                </Row>

                <Row className="mov-input">
                    <Col span={6}>
                        Remarks: 
                    </Col>  
                    
                    <Col span={18}>
                        <Input.TextArea
                            rows={3}
                            defaultValue={remarks || ''}
                            placeholder="Add a remark" 
                            name="remarks"
                            onChange={(e) => this.onInputChange(e)}
                            size="small" />
                    </Col>
                </Row>
            </Card>
        )
    }


    constructor(props) {
        super(props);
        this.state = {
            editting: false,
            movAmount: null,
            remarks: '',
            loading: false
        }
    }
    
    componentWillMount() {
        this.setState({
            movAmount: this.props.movAmount,
            remarks: this.props.remarks
        })
    }

    handleCancel = () => {
        this.setState({
            editting: false
        })
    }

    handleSubmit = () => {

        const { movAmount, remarks } = this.state;
        this.setState({
            loading: true
        })

        // console.log("mov = " , movAmount , " remarks = " , remarks)
        setTimeout(() => {
            if(this.validateInput(movAmount)) {
                _postUpdatedSupplierDetails({
                    supplierId: this.props.supplierId,
                    movAmount,
                    remarks
                })
                .then(() => {
                    message.success("Updated MOV");
                    this.setState({
                        editting: false,
                        loading: false
                    })
                })
                .catch( err => {
                    this.setState({
                        loading: false
                    })
                    message.error("Update unsuccessful")
                })
            } else {
                message.error(" MOV must be a numerical value ")
                this.setState({
                    loading: false
                })
            }
        }, 500)
        
    }

    onInputChange = (e) => {
        // console.log("name = " , e.target.name)

        if(e.target.name === "remarks") {
            this.setState({
                remarks: e.target.value.toString()
            })
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }
    }

    toggleEditMov = () => {
        this.setState({
            editting: true
        })
    }
    
    validateInput = (movAmount) => {
        return /^(0|[1-9]\d*)$/.test(movAmount);
    }
}

export default EditSupplierDetails;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/profile-header/edit-supplier-details.js